import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

const NotificationModal = ({ 
  show, 
  handleClose, 
  title, 
  message, 
  variant = 'info' // Default to 'info', can be 'success', 'danger', 'warning'
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="sm">
      {title && (
        <Modal.Header closeButton>
          <Modal.Title as="h5">{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        {variant !== 'none' ? (
          <Alert variant={variant} className="mb-0">
            {message}
          </Alert>
        ) : (
          <p>{message}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificationModal;
